export const AUDIT_LOGS = `query audit_logs(
  $filter: AuditLogFilterInput
  $orderBy: AuditLogOrderInput
  $skip: Int
  $take: Int
) {
  audit_logs(filter: $filter, orderBy: $orderBy, skip: $skip, take: $take) {
    __typename
    ... on AuditLog {
      id
      action_id
      license_plate
      id_policy
      sent_to
      its
      user {
        username
        email
      }
      audit_log_action {
        name
      }
    }
    ... on ResultError {
      status_code
      message
    }
  }
}
`;

export const AUDIT_LOG_COUNT = `
query audit_log_count(
  $filter: AuditLogFilterInput
  $orderBy: AuditLogOrderInput
) {
  audit_log_count(filter: $filter, orderBy: $orderBy) {
    __typename
    ... on Count {
      count
    }
    ... on ResultError {
      status_code
      message
    }
  }
}
`;

export const AUDIT_LOG_FILE = `
query auditLogFile(
  $filter: AuditLogFilterInput
  $orderBy: AuditLogOrderInput
) {
  auditLogFile(filter: $filter, orderBy: $orderBy) {
    __typename
    ... on BaseFile {
      filename
      mimetype
      encoding
      file
    }
    ... on ResultError {
      status_code
      message
    }
  }
}
`;
